import currencies from '@/config/currencies.json';
import state from './state';

const getters = {
  expiredCampaign: state => state.params.expired,
  campaignSlug: state => state.campaignSlug,
  campaign: state => state.params.campaign,
  projects: (state, getters) => state.params.campaign.projects.find(t => t.langue === getters.currentLang).traductions,
  personalInfo: state => {
    return state.personalInfo;
  },
  jeVeuxFaireUneDedicace: state => state.jeVeuxFaireUneDedicace,
  dedicaceInfo: state => {
    return state.dedicaceInfo;
  },
  contactInfo: state => {
    return state.contactInfo;
  },
  donationInfo: state => {
    return state.donationInfo;
  },
  donationTypes: state => state.params.donationTypes,
  params: state => state.params,
  paramsMultilingue: state => state.paramsMultilingue,
  formParams: state => state.params.formParams,
  countries: state => state.params.countries,
  provinces: state => state.params.provinces,
  civilities: state => state.params.civilities,
  receptionsInfosDons: state => state.params.receptionsInfosDons,
  frequences: state => state.params.frequences,
  faitDeLaPartDe: state => state.params.faitDeLaPartDe,
  statutsEnfant: state => state.params.statutsEnfant,
  programmesEtude: state => state.params.programmesEtude,
  equipes: state => state.params.equipes,
  typesDedicaces: state => state.params.typesDedicaces,
  typesCommunications: state => state.params.typesCommunications,
  sortedDisplayDaysOfMonthPayment: state => state.params.displayDaysOfMonthPayment.sort((a, b) => parseInt(a.name) < parseInt(b.name) ? -1 : 1),
  langues: state => state.langues,
  currentLang: state => state.currentLang,
  currentLangId: (state, getters) => getters.langues.find(l => l.name === getters.currentLang).id,
  paysafeLocale: state => {
    if (state.currentLang === 'EN') {
      return 'en_US'
    }
    return 'fr_CA'
  },
  traductions: state => state.traductions,
  t(state, getters) {
    return (code) => {
      var found = state.constantes.find(c => c.code === code)
      if (found) {
        return found.name ? found.name : code + '_' + getters.currentLang
      } else {
        return code
      }
    }
  },
  defaultCountry: state =>
    state.params.formParams.defaultCountry ?
      state.params.formParams.defaultCountry : null,
  defaultProvince: state =>
    state.params.formParams.defaultProvince ?
      state.params.formParams.defaultProvince : null,
  url: state => state.url,
  currency: state => currencies[state.params.formParams.currency.code],
  currencyCode: state => state.params.formParams.currency.code,
  infosPaysafe: state => state.infosPaysafe,
  isOutlined: state => state.params.formParams.typeDeChamp.includes("outlined"),
  isDense: state => state.params.formParams.typeDeChamp.includes("dense"),
};

export default getters;